import { AdditionalSelectors } from '@makemydeal/dr-activities-role-assumption';
import { getBffApiUrl } from '@makemydeal/dr-dash-ui-utils';

export const additionalSelectors: AdditionalSelectors = {
    getValidateUserURL: () => {
        return getBffApiUrl('role-assumption/validation');
    }
};
